import React from 'react'
import abt1 from '../Assets/About-US/about1.webp'
import abt2 from '../Assets/About-US/about2.webp'
import abt3 from '../Assets/About-US/about3.webp'
import abt4 from '../Assets/About-US/about4.webp'
import abt5 from '../Assets/About-US/about5.webp'
import abt6 from '../Assets/About-US/about6.webp'
import abt7 from '../Assets/About-US/about7.webp'
import abt8 from '../Assets/About-US/about8.webp'
import abt9 from '../Assets/About-US/about9.webp'
import abt10 from '../Assets/About-US/about10.webp'
import abt11 from '../Assets/About-US/about11.webp'
import abt12 from '../Assets/About-US/about12.webp'
import abt13 from '../Assets/About-US/about13.webp'
import abt14 from '../Assets/About-US/about14.webp'
import abt15 from '../Assets/About-US/about15.webp'
import abt16 from '../Assets/About-US/about16.webp'


const AboutUs = () => {



  return (
    <div id='About' className="AboutUs">
      <div className="about-title">
        <h3> Largest educational group with best placements</h3>
        <h1>ABOUT US</h1>
      </div>
      <div className="about-containor">

   <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt1} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Established in 1999</h2>
      <p>
      Established in 1999 – Oldest & Largest NBA Accredited Educational Group of Central India
      </p>
      <a href="#">Read More!</a>
    </div>
  </div>

 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt2} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Engineering Institutes</h2>
      <p>
      Engineering Institutes Approved by AICTE India and Affiliated to RGPV, Bhopal
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt3} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Pharmacy Institutes</h2>
      <p>
      Pharmacy Institutes Approved by Pharmacy Council of India
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt4} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Management Institute</h2>
      <p>
      Management Institute Affiliated to Barkatullah University, Bhopal
      </p>
      <a href="#">Read More!</a>
    </div>
  </div>

 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt5} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Commerce & Sciences Institute</h2>
      <p>
      Commerce & Sciences Institute Affiliated to Barkatullah University, Bhopal
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt6} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Law Institute</h2>
      <p>
      Law Institute Affiliated to Barkatullah University, Bhopal
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt7} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Paramedical Institute</h2>
      <p>
      Paramedical Institute, Bhopal
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt8} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Nursing Institute</h2>
      <p>
      Nursing Institute affiliated to MPMSU, Jabalpur
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt9} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>6,200+ intake</h2>
      <p>
      6,200+ intake with 17,000+ Students on Campus, 1,469+ faculty members
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt10} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Offering Bachelors</h2>
      <p>
      Offering Bachelors to Ph. D. level Programs across Engineering, Pharmacy & Management
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt11} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>5,915+ Apple/HP/Lenovo</h2>
      <p>
      5,915+ Apple/HP/Lenovo Core i7/i5/i3 Computers, 552 Mbps lease line internet connection
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt12} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>635 Labs</h2>
      <p>
      Built up Area of 15 Lakh sqft with 337 Smart Classrooms, 635 Labs & 26 Seminar & 26 Conf. Halls
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt13} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>National Journals</h2>
      <p>
      3,04,310+ Books, 41,119+ Titles, 703 National Journals and 296 International Journals
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt14} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Students placed</h2>
      <p>
      3,217+ Students placed (2022 & 23 Batch)
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt15} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Online Class</h2>
      <p>
      Online Class Conduction
      </p>
      <a href="#">Read more</a>
    </div>
  </div>
 <div className="about-thumbnail">
    <div className="about-galary">
      <img src={abt16} alt="" />
    </div>
    <div className="about-galary-des">
      <h2>Diploma in Engineering</h2>
      <p>
      Diploma in Engineering
      </p>
      <a href="#">Read more</a>
    </div>
  </div>


  </div>
    </div>
  );
}

export default AboutUs;
